export const PlayerEvents = {
    loadScript: new CustomEvent('videoPlayer.loadScript'),
    play: new CustomEvent('videoPlayer.play'),
    ready: new CustomEvent('videoPlayer.ready'),
    scriptLoaded: new CustomEvent('videoPlayer.scriptLoaded'),
    stateChange: new CustomEvent('videoPlayer.stateChange'),
    stop: new CustomEvent('videoPlayer.stop')
};
/**
 @abstract
 */
class Player {
    constructor(element) {
        if (new.target === Player) {
            throw new TypeError('Cannot construct Abstract instances directly');
        }
        this.element = element;
        this.events = PlayerEvents;
    }
    onPlayerReady() {
        this.element.dispatchEvent(this.events.ready);
    }
    onPlayerStateChange() {
        this.element.dispatchEvent(this.events.stateChange);
    }
    importScript(url, id, onload = null) {
        var _a;
        const firstScriptTag = document.getElementsByTagName('body')[0].getElementsByTagName('script')[0];
        const script = document.createElement('script');
        script.async = false;
        script.id = id;
        script.onload = onload;
        script.src = url;
        (_a = firstScriptTag.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, firstScriptTag);
    }
    /* Abstract methods */
    play() {
        throw new Error('Abstract method!');
    }
    stop() {
        throw new Error('Abstract method!');
    }
    mute() {
        throw new Error('Abstract method!');
    }
    unmute() {
        throw new Error('Abstract method!');
    }
}
export default Player;
